// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import MeansTesting from './calculators/MeansTesting';
import StepQuestionnaire from './calculators/StepQuestionnaire';
import CreateFirm from './calculators/CreateFirm';  // Adjust path if needed
import FirmLogin from './calculators/FirmLogin';  // Adjust path if needed
import ResetPassword from './calculators/ResetPassword';
import FirmDashboard from './pages/FirmDashboard';
import CaseSearchPage from './pages/CaseSearchPage.jsx';
import FirmLeadCenter from './pages/FirmLeadCenter.jsx';
import FirmChapter13LeadCenter from './pages/FirmChapter13LeadCenter.jsx';
import AccountPage from './pages/AccountPage';
import CreateCase from './pages/CreateCase';
import AddAttorney from './pages/AddAttorney';
import './index.css';
import CaseLayout from './pages/components/CaseLayout';  // your new case layout
import CaseHome from './pages/CaseHome';            // create this page
import FormPreparation from './pages/FormPreparation'; // create this page
import DocumentsPage from './pages/DocumentsPage.jsx';      // create this page
import EmailClient from './pages/EmailClient';          // create this page
import NotesPage from './pages/NotesPage';              // create this page
import TimelinePage from './pages/TimelinePage';        // create this page
import ClientLoginPage from './pages/ClientLoginPage'; // Adjust path if needed
import SetPasswordPage from './pages/SetPasswordPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ClientResetPasswordPage from './pages/ClientResetPasswordPage.jsx';
import ClientHome from './pages/client/Home.jsx';
import CreditReport from './pages/client/CreditReport.jsx';
import ClientOneView from './pages/client/ClientOneView.jsx';
import RetainerAgreementPage from './pages/client/RetainerAgreementPage.jsx';
import ClientFormsPage from './pages/client/ClientFormsPage.jsx';
import ClientPaymentsPage from './pages/client/ClientPaymentsPage.jsx';
import ClientFAQPage from './pages/client/ClientFAQPage.jsx';
import ClientDocumentsPage from './pages/client/ClientDocumentPage.jsx';
import ClientDashboardLayout from './pages/components/ClientDashboardLayout.jsx';
import Creditors from './pages/client/Creditors.jsx';
import FirmCreditors from './pages/FirmCreditors.jsx'
import FirmCreditReport from './pages/FirmCreditReport.jsx'
import ProtectedRoute from './ProtectedRoute.tsx'
import Chapter13PlanCalculator from './calculators/Chapter13PlanCalculator.js';
import QuickIntakeForm from './components/QuickIntakeForm.jsx';
import PaymentPortal from './pages/PaymentPoral.jsx';
import FilingFeePortal from './pages/FilingFeePortal.jsx';
import FirmPaymentPage from './pages/FirmPaymentPage.jsx';
import FirmRetainerPage from './pages/FirmRetainerPage.jsx';
import VoluntaryPetition from './pages/forms/VoluntaryPetition.jsx'
import ScheduleDEF from './pages/FirmCreditors.jsx';
import FirmOneView from './pages/client/FirmOneView.jsx';
import CaseDockets from './pages/CaseDockets.jsx';
import ScheduleABC from './pages/forms/ScheduleABC.jsx';
import ScheduleIJ from './pages/forms/ScheduleIJ.jsx';
import Sofa from './pages/forms/SOFA.jsx';
import AllForms from './pages/forms/AllForms.jsx';
import WageOrder from './pages/WageOrder.jsx';
import ReaffirmationExtension from './pages/ReaffirmationExtension.jsx';
import LienAvoidance from './pages/LienAvoidance.jsx';
import Chapter13PlanPage from './pages/Chapter13PlanPage.jsx';
import OmittedLetterPage from './pages/OmittedLetterPage.jsx';
import GarnishmentPacketPage from './pages/GarnishmentPacketPage.jsx';
import LeadsPage from './pages/LeadsPage.jsx';
import FirmArchive from './pages/FirmArchive.jsx';
import FirmManagementPage from './pages/FirmManagementPage.jsx';
import PublicTaxReturnUpload from './pages/PublicTaxReturnUpload.jsx';
import PublicNonFilerAffidavit from './pages/PublicNonFilerAffidavit.jsx';
import PublicPostFilingDocumentsUpload from './pages/PublicPostFilingDocumentsUpload.jsx';
import CaseReaffirmations from './pages/CaseReaffirmations.jsx';
import ClientReaffirmUpload from './pages/ClientReaffirmUpload.jsx';
import TrusteeDocTemplatesPage from './pages/TrusteeDocTemplatesPage.jsx';
import TrusteeDocGenerate from './pages/TrusteeDocGenereate.jsx';
import CaseHearingsPage from './pages/CaseHearingsPage.jsx';
import FirmHearingsPage from './pages/FirmHearingsPage.jsx';
import CaseDateReportPage from './pages/CaseDateReportPage.jsx';
import SubstitutionCounselLandingPage from './pages/SubstitutionCounselLandingPage.jsx';
import SubstitutionCounselCasePage from './pages/SubstitutionCounselCasePage';
import RouteFavicon from './components/RouteFavicon.jsx';
import TodaysTodosPage from './pages/TodaysTodosPage.jsx';
import Meeting341WorkboardPage from './pages/Meeting341WorkboardPage.jsx';
import ReaffirmationWorkboardPage from './pages/ReaffirmationWorkboardPage.jsx';
import ProspectLawsuitReportPage from './pages/ProspectLawsuitReportPage.jsx';
import WorkoutPage from './pages/WorkoutPage.jsx';
import { loadMeansTestStandards } from './utils/meansTestStandards';
import { Capacitor } from '@capacitor/core';
import MobileShell, { MobileLanding } from './mobile/MobileShell';
import NotificationCenter from './mobile/NotificationCenter';
import ClientProtectedRoute from './mobile/ClientProtectedRoute';

function MeansTestStandardsLoader() {
  const { pathname } = useLocation();

  useEffect(() => {
    const standardsRoute = [
      '/means-test',
      '/intake',
      '/chapter-13-plan-calculator',
      '/form-sub',
      '/create-case',
      '/case/',
    ].some((prefix) => pathname.startsWith(prefix));

    if (standardsRoute) {
      loadMeansTestStandards().catch((error) => {
        console.error('Using bundled means-test standards:', error);
      });
    }
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <MobileShell />
      <RouteFavicon />
      <MeansTestStandardsLoader />
      <div className="App">
        {/* Navigation Links }
        <nav>
          <ul>
            <li><Link to="/means-test">Means Test Calculator</Link></li>
            <li><Link to="/intake">Bankruptcy Intake</Link></li>
          </ul>
        </nav>

        { Define Routes for different pages */}
        
        <Routes>
          <Route path="/" element={Capacitor.isNativePlatform() ? <MobileLanding /> : <ClientLoginPage />} />
          <Route element={<ClientProtectedRoute />}>
          <Route path="/client/dashboard" element={<ClientDashboardLayout />}>
            <Route index element={<ClientHome />} />
            <Route path="credit-report" element={<CreditReport />} />
            <Route path="oneview" element={<ClientOneView />} />
            <Route path="creditors" element={<Creditors />} />
            <Route path="documents" element={<ClientDocumentsPage />} />
            <Route path="faq" element={<ClientFAQPage />} />
            <Route path="forms" element={<ClientFormsPage />} />
            <Route path="retainer" element={<RetainerAgreementPage />} />
            <Route path="payments/:amount" element={<ClientPaymentsPage />} />
            <Route path="payments" element={<ClientPaymentsPage />} />
            <Route path="notifications" element={<NotificationCenter />} />
          </Route>
          </Route>
          <Route path="/substitution-counsel" element={<SubstitutionCounselLandingPage />} />
          <Route
  path="/substitution-counsel/case/:publicToken"
  element={<SubstitutionCounselCasePage />}
/>
          <Route path="/reset-password/:uid/:token" element={<ClientResetPasswordPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/set-password" element={<SetPasswordPage />} />
          <Route path="/client/login" element={<ClientLoginPage />} />
          <Route path="/means-test" element={<MeansTesting />} />
          <Route path="/payments/:caseId/:amount" element={<PaymentPortal />} />
          <Route path="/filing-fee/:caseId/:amount" element={<FilingFeePortal />} />
          <Route path="/chapter-13-plan-calculator" element={<Chapter13PlanCalculator />} />
          <Route path="/form-sub" element={<QuickIntakeForm />} />
          <Route path="/intake" element={<StepQuestionnaire />} />
          <Route path="/create-firm" element={<CreateFirm />} />
          <Route path="/login-firm" element={<FirmLogin />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/public/tax-return/:tokenId" element={<PublicTaxReturnUpload />} />
          
<Route path="/client/reaffirm/:token" element={<ClientReaffirmUpload />} />
<Route path="/public/tax-return/:tokenId/non-filer" element={<PublicNonFilerAffidavit />} />  
          <Route path="/public/post-filing-documents/:tokenId" element={<PublicPostFilingDocumentsUpload />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/notifications" element={<NotificationCenter />} />
            <Route path="/create-case" element={<CreateCase />} />
            <Route path="/add-attorney" element={<AddAttorney />} />
            <Route path="/lead-center" element={<FirmLeadCenter />} />
            <Route path="/chapter-13-lead-center" element={<FirmChapter13LeadCenter />} />
            <Route path="/dashboard" element={<FirmDashboard />} />
            <Route path="/todays-todos" element={<TodaysTodosPage />} />
            <Route path="/341-workboard" element={<Meeting341WorkboardPage />} />
            <Route path="/reaffirmation-workboard" element={<ReaffirmationWorkboardPage />} />
            <Route path="/workouts" element={<WorkoutPage />} />
            <Route path="/case-search" element={<CaseSearchPage />} />
            <Route path="/firm-hearings" element={<FirmHearingsPage />} />
            <Route path="/reports/case-date" element={<CaseDateReportPage />} />
            <Route path="/reports/prospect-lawsuits" element={<ProspectLawsuitReportPage />} />
            <Route path="/leads" element={<LeadsPage />} />
            <Route path="/archived" element={<FirmArchive />} />
            <Route path="/account" element={<FirmManagementPage />} />
            <Route path="/trustee-templates" element={<TrusteeDocTemplatesPage />} />
            <Route path="/case/:caseId" element={<CaseLayout />}>
              <Route index element={<CaseHome />} />
              <Route path="letters/omitted" element={<OmittedLetterPage />} />
              <Route path="trustee-docs" element={<TrusteeDocGenerate />} />
              <Route path="forms" element={<FormPreparation />} />
              <Route path="dockets" element={<CaseDockets />} />
              <Route path="forms/voluntary-petition" element={<VoluntaryPetition />} />
              <Route path="forms/schedule-d-e-f" element={<ScheduleDEF />} />
              <Route path="forms/schedule-a-bc" element={<ScheduleABC />} />
              <Route path="forms/schedule-ij" element={<ScheduleIJ />} />
              <Route path="forms/sofa" element={<Sofa />} />
              <Route path="forms/chapter-13-plan" element={<Chapter13PlanPage />} />
              <Route path="forms/all" element={<AllForms />} />
              <Route path="forms/wage-order" element={<WageOrder />} />
              <Route path="motions/reaffirmation-extension" element={<ReaffirmationExtension />} />
              <Route path="motions/avoid-lien" element={<LienAvoidance />} />
              <Route path="documents" element={<DocumentsPage />} />
              <Route path="creditors" element={<FirmCreditors />} />
              <Route path="credit-report" element={<FirmCreditReport />} />
              <Route path="oneview" element={<FirmOneView />} />
              <Route path="email" element={<EmailClient />} />
              <Route path="notes" element={<NotesPage />} />
              <Route path="timeline" element={<TimelinePage />} />
              <Route path="payment" element={<FirmPaymentPage />} />
              <Route path="retainer" element={<FirmRetainerPage />} />
              <Route path="reaffirmations" element={<CaseReaffirmations />} />
              <Route path="hearings" element={<CaseHearingsPage />} />
              <Route path="letters/garnishment" element={<GarnishmentPacketPage />} />
            </Route>
          </Route>
          {/* Optionally, a default/fallback route */}
          <Route path="*" element={<ClientLoginPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
